import Branding from 'domain/entity/branding';
import { Color, ColorType, Period, PeriodType } from 'domain/entity/widgetData';
import { parseISO } from 'date-fns';
import moment from 'moment';

export const getColor = (branding: Branding) => (color: Color): string => {
    switch (color.type) {
        case ColorType.PRIMARY:
            return branding.primaryColor;
        case ColorType.BACKGROUND:
            return branding.backgroundColor;
        case ColorType.BY_DEFAULT:
        default:
            return color.byDefault.replace('0x', '#');
    }
};

export const getPeriodFrom = (period: Period, format: string): string => {
    switch (period.type) {
        case PeriodType.TEXT: {
            return period.text != null ? period.text.toLowerCase() : '';
        }
        case PeriodType.INTERVAL:
        default: {
            return period.from != null ? defaultDateFormatter(period.from, format.toUpperCase()) : '';
        }
    }
};

export const getPeriodTo = (period: Period, format: string): string => {
    switch (period.type) {
        case PeriodType.TEXT: {
            return '';
        }
        case PeriodType.INTERVAL:
        default: {
            return period.to != null ? defaultDateFormatter(period.to, format.toUpperCase()) : '';
        }
    }
};

export const adjustForUTCOffset = (date: Date) =>
    new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());

export const defaultDateFormatter = (date: Date, dateFormat: string): string => {
    const ISOdate = parseISO(date.toISOString());
    const dateWithOffset = adjustForUTCOffset(ISOdate);
    return moment(dateWithOffset).format(dateFormat);
};
